import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Home, FileText, BarChart3, User, LogOut, ChevronLeft, ChevronRight } from 'lucide-react';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  const navItems = [
    { name: 'Overview', path: '/dashboard', icon: Home },
    { name: 'My Forms', path: '/dashboard/forms', icon: FileText },
    { name: 'Account', path: '/dashboard/account', icon: User },
  ];

  const handleLogout = () => {
    // Add logout logic here
    navigate('/signin');
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <aside
        className={`hidden lg:flex flex-col bg-blue-600 transition-all duration-500 ease-out ${
          isOpen ? 'w-64' : 'w-20'
        }`}
      >
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-4 ">
          {isOpen && (
            <span className="text-2xl font-bold text-white tracking-tight">
              
            </span>
          )}
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 transition-all duration-300"
          >
            {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-6 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.path === '/dashboard'}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group relative overflow-hidden ${
                  isActive
                    ? 'bg-white/20 text-white backdrop-blur-sm border border-white/30'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                } ${!isOpen && 'justify-center'}`
              }
            >
              {({ isActive }) => (
                <>
                  {/* Active state glow effect */}
                  {isActive && (
                    <div className="absolute inset-0 bg-mintGlow opacity-20 rounded-xl" />
                  )}
                  
                  <item.icon 
                    size={20} 
                    className={`relative z-10 transition-transform duration-300 ${
                      !isOpen ? 'group-hover:scale-110' : ''
                    } ${isActive ? 'text-mint' : 'text-white/80'}`} 
                  />
                  {isOpen && (
                    <span className={`font-medium relative z-10 ${
                      isActive ? 'text-white' : 'text-white/80 group-hover:text-white'
                    }`}>
                      {item.name}
                    </span>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Logout */}
        <div className="px-3 py-4">
          <button
            onClick={handleLogout}
            className={`flex items-center gap-3 px-4 py-3 w-full rounded-xl text-white transition-all duration-300 group ${
              !isOpen && 'justify-center'
            }`}
          >
            <LogOut 
              size={20} 
              className={`transition-transform duration-300 ${
                !isOpen ? 'group-hover:scale-110' : ''
              }`} 
            />
            {isOpen && <span className="font-medium">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Mobile Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-blue backdrop-blur-sm transform transition-all duration-500 ease-out lg:hidden ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-white/20">
          <span className="text-2xl font-bold text-white tracking-tight">
            Fylo
          </span>
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 transition-all duration-300"
          >
            <ChevronLeft size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-6 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.path === '/dashboard'}
              onClick={toggleSidebar}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 relative overflow-hidden ${
                  isActive
                    ? 'bg-white/20 text-white backdrop-blur-sm border border-white/30'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {/* Active state glow effect */}
                  {isActive && (
                    <div className="absolute inset-0 bg-mintGlow opacity-20 rounded-xl" />
                  )}
                  
                  <item.icon 
                    size={20} 
                    className={`relative z-10 ${isActive ? 'text-mint' : 'text-white/80'}`} 
                  />
                  <span className="font-medium relative z-10">{item.name}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>

{/* Logout */}
<div className="px-3 py-4 border-t border-white-600/30">
<button
  onClick={handleLogout}
  className="flex items-center gap-3 px-4 py-3 w-full rounded-xl 
             text-white/80 hover:text-white
             transition-all duration-300"
>
  <LogOut size={20} />
  <span className="font-medium">Logout</span>
</button>
</div>

      </aside>
    </>
  );
};

export default Sidebar;